import styled from 'styled-components';

import colors from '../../style/colors';
import { actionColor, actionLight } from '../../style/theme-helpers';
import BaseCard, { BaseCardProps } from './base-card';

const CardBorderButton = styled(BaseCard)<BaseCardProps>`
  transition: all 600ms ease;
  background: ${colors.white};
  border: 1px solid ${colors.gray300};

  &:hover:not(.disabled):not([disabled]),
  &:active {
    box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    background: ${actionLight};
    * {
      color: ${actionColor} !important;
    }
    border-color: ${actionColor};
  }

  &:focus-visible,
  &.active {
    border-color: ${props => props.theme.actionColor};
  }
`;

export default CardBorderButton;
